<template>
    <div>
        <el-dialog v-model="signInRuleShow" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false">
            <div class="dialog_content">
                <div class="rule_content p-20 scroll_y hidden_scroll" v-html="signInRuleContent"> </div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="30" color="#fff">
                        <circle-close />
                    </el-icon>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5SignInRule",
    props: {

    },

    data() {
        return {
            signInRuleShow: false,
            signInRuleContent:'',
        };
    },

    mounted() { },

    methods: {
        closePopup() {
            this.signInRuleShow = false;
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: none;
    border-radius: 10px;
    padding: 0;
    width: 814px;
    height: 838px;
    position: relative;
    background: transparent;
}

:deep(.el-dialog__header) {
    display: none;
}

.dialog_content {
    position: relative;
    z-index: 9;
    width: 814px;
    height: 838px;
    background-size: cover;
    background-repeat: no-repeat;

    .rule_content {
        position: absolute;
        top: 220px;
        left: 220px;
        width: 366px;
        height: 425px;
        background: #FFFFFF;
        border-radius: 30px;
        font-size: 16px;
        color: #606060;
        line-height: 22px;
        box-sizing: border-box;
         white-space: pre-line; /* 将 \n 转换为换行，合并连续空格 */
  word-break: break-word; /* 允许单词内断行防止溢出 */
  overflow-wrap: anywhere; /* 更智能的溢出换行策略 */
    }

    .close_icon {
        position: absolute;
        right: 180px;
        top: 190px;
    }
}
</style>